import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogClose,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { LoaderCircle } from 'lucide-react'

const ConfirmationDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title = 'Confirm Action',
    description = 'Are you sure you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'destructive',
    buttonClassName,
    isProcessing = false,
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="tw:!w-lg">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <DialogDescription>{description}</DialogDescription>
                <DialogFooter className="tw:gap-4 tw:py-4">
                    <DialogClose asChild>
                        <Button variant="secondary" disabled={isProcessing}>
                            {cancelText}
                        </Button>
                    </DialogClose>

                    <Button variant={variant} className={buttonClassName} onClick={onConfirm} disabled={isProcessing}>
                        <div className="tw:relative tw:flex tw:items-center tw:justify-center">
                            <LoaderCircle
                                className={`tw:w-4 tw:h-4 tw:animate-spin tw:absolute ${isProcessing ? 'tw:opacity-100' : 'tw:opacity-0'}`}
                            />
                            <span className={isProcessing ? 'tw:opacity-0' : 'tw:opacity-100'}>{confirmText}</span>
                        </div>
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default ConfirmationDialog
